export default __webpack_public_path__ + "static/media/VideoCamera.55bbfd24.svg";